import React, { useState } from 'react';
import { GradientTextAction } from 'src/common';
import { SuggestFrameworksModal } from 'src/components/modals';
import { ControlQuery } from 'src/graphql/_generated';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';

interface SuggestedFrameworksProps {
  control: NonNullable<ControlQuery['control']>;
}

export const SuggestedFrameworks: React.FC<SuggestedFrameworksProps> = ({ control }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {isOpen && <SuggestFrameworksModal onClose={() => setIsOpen(false)} control={control} />}
      <>
        <GradientTextAction
          style={{ display: 'inline-block', marginRight: 'auto', textTransform: 'none', cursor: 'pointer' }}
          weight={500}
          onClick={() => {
            mpEvent(MPEvents.ButtonClick, {
              button: 'Suggested frameworks',
              tags: ['CONTROL', 'RMP', 'FRAMEWORK'],
            });
            setIsOpen(!isOpen);
          }}
          data-cy="add-framework-control"
        >
          + <span className="underline">Add source framework</span>
        </GradientTextAction>
      </>
    </>
  );
};
